export enum PAYMENT_STATE {
    WAITING = 'WAITING',
    REALISED = 'REALISED',
    CANCELLED = 'CANCELLED',
}
